import { render, staticRenderFns } from "./BatchImageUpload.vue?vue&type=template&id=d260b05e&scoped=true"
import script from "./BatchImageUpload.vue?vue&type=script&lang=js"
export * from "./BatchImageUpload.vue?vue&type=script&lang=js"
import style0 from "./BatchImageUpload.vue?vue&type=style&index=0&id=d260b05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d260b05e",
  null
  
)

export default component.exports